export default class contactManager {
    constructor(){
        this.status = {
            flg : false,
            containFlg: false
        }

        this.form = document.getElementById("js__form");
        this.check = document.querySelectorAll(".js__required");
        this.submitBtn = document.getElementById("js__submit");
        this.error = document.getElementsByClassName('error');
        this.errorKatakana = document.getElementsByClassName('error-katakana');
        this.errorEmail = document.getElementsByClassName('error-email');
        // this.method = document.getElementsByClassName('method');
        this.radio = document.querySelectorAll("input");
        this.radioTel = document.querySelectorAll("input[type=tel]");
        this.target = '';
        this.index = 0;
        this.val = '';
        this.methodPhone = document.getElementById('method-phone');
        this.methodFax = document.getElementById('method-fax');
        this.methodEmail = document.getElementById('method-email');
        this.inputPhone = document.getElementById('input-phone');
        this.inputFax = document.getElementById('input-fax');
        this.inputEmail = document.getElementById('input-email');

    }
    init(){
        let _this = this;
        this.validate();
        this.submit();

        //blur
        this.blur();

        //change
        this.change();

        //submit
        this.form.addEventListener("input",function () {
            _this.validate();
            _this.submit();
        });
        this.form.addEventListener("blur",function () {
            _this.validate();
            _this.submit();
        });

        //method
        this.form.addEventListener("change",() => {
            this.method();
        });
        this.method();

        //[ 半角へ変換 ]
        for(let i = 0; i < this.radio.length; i++){
            this.radio[i].addEventListener("change",() => {
                let _text  = this.radio[i].value;
                let _han = _text.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
                this.radio[i].value = _han;
            });
        }

        //[ 数字のみ入力 ]
        for(let i = 0; i < this.radioTel.length; i++){
            this.radioTel[i].addEventListener('keypress', (e) => {
                let _k = e.keyCode;
                // 0～9, テンキ―0～9, スペース, backspace, delete, →, ←, 以外は入力キャンセル
                if(!((_k >= 48 && _k <= 57) || (_k >= 96 && _k <= 105) || _k == 32 || _k == 8 || _k == 46 || _k == 39 || _k == 37)) {
                    e.preventDefault();
                }
            });
        }

    }

    submit(){
        if(this.status.flg && this.status.containFlg){
            TweenMax.set(this.submitBtn,{className:"-=disabled"});
            this.submitBtn.disabled = false;
        }else{
            TweenMax.set(this.submitBtn,{className:"+=disabled"});
            this.submitBtn.disabled = true;
        }
    }

    blur(){
        let _this = this;
        for(let i = 0; i < this.check.length ; i++){
            (function(num) {
                _this.check[i].addEventListener('blur', function() {
                    _this.index = num;
                    _this.target = _this.check[i];
                    // _this.target = _this.check[i];
                    _this.errorSet();
                    _this.katakanaCheck();
                    _this.emailCheck();
                    _this.validate();
                    _this.submit();
                });
            })(i);
        }
    }

    change(){
        let _this = this;
        for(let i = 0; i < this.check.length ; i++){
            (function(num) {
                _this.check[i].addEventListener('change', function() {
                    _this.index = num;
                    _this.target = _this.check[i];
                    // _this.target = _this.check[i];
                    _this.errorSet();
                    _this.katakanaCheck();
                    _this.emailCheck();
                    _this.validate();
                    _this.submit();
                });
            })(i);
        }
    }

    method(){
        if(document.getElementById('email').checked){
            TweenMax.set([this.inputPhone,this.inputFax,this.inputEmail],{className:"-=error"});
            TweenMax.set(this.methodEmail,{className:"+=must"});
            TweenMax.set([this.methodFax,this.methodPhone],{className:"-=must"});
            TweenMax.set(this.inputEmail,{className:"+=js__required"});
            TweenMax.set([this.inputFax,this.inputPhone],{className:"-=js__required"});
        }
        if(document.getElementById('phone').checked){
            TweenMax.set([this.inputPhone,this.inputFax,this.inputEmail],{className:"-=error"});
            TweenMax.set(this.methodPhone,{className:"+=must"});
            TweenMax.set([this.methodFax],{className:"-=must"});
            TweenMax.set(this.inputPhone,{className:"+=js__required"});
            TweenMax.set([this.inputFax],{className:"-=js__required"});
        }
        if(document.getElementById('fax').checked){
            TweenMax.set([this.inputPhone,this.inputFax,this.inputEmail],{className:"-=error"});
            TweenMax.set(this.methodFax,{className:"+=must"});
            TweenMax.set([this.methodPhone],{className:"-=must"});
            TweenMax.set(this.inputFax,{className:"+=js__required"});
            TweenMax.set([this.inputPhone],{className:"-=js__required"});
        }
        this.check = document.querySelectorAll(".js__required");
        this.blur();

        this.validate();
        this.submit();
    }


    katakanaCheck(){
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;


        if(_id.match(/seikana/g) || _id.match(/meikana/g)){
            if(_val==""){
                this.errorSet();
            }else{
                if(!_val.match(/^[ァ-ロワヲンー 　\r\n\t]*$/)){
                    this.reset();
                    TweenMax.set(this.target,{className:"+=error-katakana"});
                }
            }
        }
    }

    emailCheck(){
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;


        if(_id.match(/input-email/g)){
            if(_val==""){
                this.errorSet();
            }else{
                if(!_val.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)){
                    this.reset();
                    TweenMax.set(this.target,{className:"+=error-email"});
                }
            }
        }
    }

    errorSet(){
        this.reset();
        if(this.target.value===""){
            TweenMax.set(this.target,{className:"+=error"})
        }
    }


    validate(){
        let i=0;
        while(i < this.check.length){
            if(this.check[i].value === ''){
                this.status.containFlg = false;
                break;
            }else{
                this.status.containFlg = true;
            }
            i++;
        }

        if(document.getElementsByClassName('error').length > 0  || document.getElementsByClassName('error-katakana').length > 0 || document.getElementsByClassName('error-email').length > 0) {
            this.status.flg = false;
        }else{
            this.status.flg = true;
        }
    }

    reset(){
        if(this.error != null) {
            TweenMax.set(this.target,{className:"-=error"});
        }
        if(this.errorKatakana != null){
            TweenMax.set(this.target,{className:"-=error-katakana"});
        }
        if(this.errorEmail != null){
            TweenMax.set(this.target,{className:"-=error-email"});
        }

    }

    resize(){

    }


}